import React, { FunctionComponent } from 'react'

import { Trans } from 'react-i18next'

import { SurveyWindow } from 'store/surveyWindow/types'

import { PromptCard } from './PromptCard'

interface SurveyWindowOpenProps {
  currentSurveyWindow: SurveyWindow
}

export const SurveyWindowOpen: FunctionComponent<SurveyWindowOpenProps> = ({
  currentSurveyWindow,
}) => (
  <PromptCard
    title="surveys.open.title"
    progress={{
      max: currentSurveyWindow.totalInvited,
      value: currentSurveyWindow.totalCompleted,
    }}
    guidance={<Trans i18nKey="surveys.open.guidance" />}
  />
)
